import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { ThumbnailImage } from "../../thumbnail/image.js";
import { SliderThumbnailRoot } from "./root.js";
//#region src/ui/slider/thumbnail/index.parts.ts
var index_parts_exports = /* @__PURE__ */ __exportAll({
	Image: () => ThumbnailImage,
	Root: () => SliderThumbnailRoot
});
//#endregion
export { ThumbnailImage as Image, SliderThumbnailRoot as Root, index_parts_exports };

//# sourceMappingURL=index.parts.js.map